<div>
    <div class="my-5">
        <div class="w-9/12 m-auto py-16 min-h-screen flex items-center justify-center">
            <div class="bg-white overflow-hidden sm:rounded-lg pb-8">
                <div class="border-t border-gray-200 text-center pt-8">
                    <h1 class="text-9xl font-bold text-purple-400">404</h1>
                    <h1 class="text-6xl font-medium py-8">Pagina non trovata</h1>
                    <p class="text-2xl pb-8 px-12 font-medium">La pagina che stai cercando non è stata trovata, torna alla pagina principale e riprova</p>
                    <button type="button" class="btn btn-primary btn-lg" (click)="routeTo('/home')">Homepage</button>
                </div>
            </div>
        </div>
    </div>
</div>